import React from "react";
import axios from "axios";
import { TextField, Button, Container, InputLabel, Select, MenuItem } from "@material-ui/core";
import Table from "literacy/components/tutor/thread-data-table/blank-table";

class PhonemeTutorPhonemeData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      blankAnswerDataW1: [],
      blankAnswerDataW2: [],
      blankAnswerAccess: [],
      question: "",
      answer: "",
      section: "w1",
      hint: ""
    };
  }

  componentDidMount = async () => {
    const doc1 = await axios.get("/api/literacy/phoneme/blank/table/w1");
    const doc2 = await axios.get("/api/literacy/phoneme/blank/table/w2");
    const doc3 = await axios.get("/api/literacy/phoneme/blank/table/access");
    if (doc1.data) {
      this.setState({ blankAnswerDataW1: doc1.data });
    }
    if (doc2.data) {
      this.setState({ blankAnswerDataW2: doc2.data });
    }
    if (doc3.data) {
      this.setState({ blankAnswerAccess: doc3.data });
    }
  };

  addNewData = async () => {
    const { answer, question, section, hint } = this.state;
    await axios.post("/api/literacy/phoneme/blank", { answer, question, version: section, hint });
    await this.setState({ answer: "", question: "", hint: "" });
    this.componentDidMount();
  };

  handleEdit = async (id, newRow) => {
    await axios.put("/api/literacy/phoneme/blank/" + id, newRow);
    this.componentDidMount();
  }

  deleteData = async (id) => {
    await axios.delete("/api/literacy/phoneme/blank/" + id);
    this.componentDidMount();
  };

  handleSectionChange = (e) => {
    this.setState({ section: e.target.value });
  }

  renderTable = () => {
    const { section, blankAnswerDataW1, blankAnswerDataW2 } = this.state;
    switch (section) {
      case "w1":
        return <Container>
          <Table
            rows={blankAnswerDataW1}
            onEdit={this.handleEdit}
            handleDelete={this.deleteData}
          />
        </Container>
      case "w2":
        return <Container>
          <Table
            rows={blankAnswerDataW2}
            onEdit={this.handleEdit}
            handleDelete={this.deleteData}
          />
        </Container>
    }
  }

  render() {
    const { question, answer, section, hint } = this.state;
    return (
      <div>
        <div className="jumbotron">
          <h2>Modify the Phoneme Blank Question Data</h2>
          <br />
          <Button variant="contained" style={{ color: "white", backgroundColor: "#107896" }} href="/literacy/tutor/phoneme">
            Go back
          </Button>
        </div>
        <Container>
          <InputLabel id="label">Assignment Section</InputLabel>
          <Select
            labelId="demo-controlled-open-select-label"
            id="demo-controlled-open-select"
            value={section}
            onChange={this.handleSectionChange}
          >
            <MenuItem value="w1">Week 1</MenuItem>
            <MenuItem value="w2">Week 2</MenuItem>
          </Select>
        </Container>
        <Container>
          <TextField
            id="standard-basic"
            label="question"
            value={question}
            autoComplete="off"
            style={{ marginRight: 20, width: 500 }}
            onChange={(e) => this.setState({ question: e.target.value })}
          />
          <br />
          <TextField
            id="standard-basic"
            label="answer"
            value={answer}
            autoComplete="off"
            style={{ marginRight: 20, width: 300 }}
            onChange={(e) => this.setState({ answer: e.target.value })}
          />
          <TextField
            label="Hint"
            autoComplete="off"
            value={hint}
            style={{ width: 300 }}
            onChange={(e) => this.setState({ hint: e.target.value })}
          />
          <br />
          <Button variant="contained" style={{ color: "white", backgroundColor: "#107896" }} style={{ marginTop: 10 }} onClick={this.addNewData}>
            Add
          </Button>
        </Container>
        <br />
        <br />
        {this.renderTable()}
        <br />
        <br />
      </div>
    );
  }
}

export default PhonemeTutorPhonemeData;
